import { FilterQuery } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { GroupedFieldValues } from '../../../types'

type HandleChange = (
  action:
    | { type: 'merge'; payload: Partial<GroupedFieldValues> }
    | { type: 'set'; payload: GroupedFieldValues }
    | null
) => void

export type UseFilterFormActionsParams = {
  handleChange: HandleChange
  handleComposition: (composition: string) => void
  clearFilterQuery?: (value: Partial<FilterQuery> | undefined) => void
  onClearSelection: () => void
}

const useFilterFormActions = ({
  handleChange,
  handleComposition,
  clearFilterQuery,
  onClearSelection
}: UseFilterFormActionsParams) => {
  const handleClear = useCallback(() => {
    handleComposition('1')
    handleChange(null)
    clearFilterQuery?.(undefined)
    onClearSelection()
  }, [handleComposition, handleChange, clearFilterQuery, onClearSelection])

  const onFieldChange = useCallback(
    (state: Partial<GroupedFieldValues>) => {
      handleChange({
        type: 'merge',
        payload: state
      })
    },
    [handleChange]
  )

  return { handleClear, onFieldChange }
}

export default useFilterFormActions
